import { render, staticRenderFns } from "./_Backgrounds.vue?vue&type=template&id=ed4b56d2&"
import script from "./_Backgrounds.vue?vue&type=script&lang=ts&"
export * from "./_Backgrounds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports